var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#FBF7F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5536 16.5445H14.473C14.3417 16.5445 14.2104 16.5968 14.1313 16.7025C14.0523 16.8072 14 16.9385 14 17.0442L15.0507 29.9681C15.0507 31.1769 16.0492 32.1743 17.2569 32.1743H25.7152C26.9239 32.1743 27.9213 31.2026 27.9213 29.9681L28.972 17.0442C28.972 16.9129 28.9454 16.7815 28.8407 16.7025C28.7894 16.5978 28.6849 16.5445 28.5536 16.5445ZM27.0298 29.9158V29.9424C27.0298 30.6515 26.4521 31.2292 25.743 31.2292H17.2837C16.5747 31.2292 15.997 30.6515 15.997 29.9424V29.9158L14.9986 17.4904H28.0539L27.0298 29.9158Z",
    fill: "#FF5956"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4732 15.81H28.527C28.7896 15.81 29 15.5997 29 15.337C29 15.0743 28.7896 14.8639 28.527 14.8639H24.9807V13.7865C24.9807 12.7881 24.1659 12 23.1942 12L19.8326 12.001C18.8342 12.001 18.0461 12.8158 18.0461 13.7875V14.8649L14.473 14.8639C14.2104 14.8639 14 15.0743 14 15.337C14 15.5997 14.2372 15.81 14.4732 15.81ZM18.9657 13.7865C18.9657 13.3135 19.3597 12.9194 19.8328 12.9194H23.1954C23.6685 12.9194 24.0625 13.3135 24.0625 13.7865V14.8639H18.9658L18.9657 13.7865Z",
    fill: "#FF5956"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.52 28.813C18.7827 28.813 18.993 28.6027 18.993 28.34L18.992 20.3803C18.992 20.1176 18.7816 19.9073 18.5189 19.9073C18.2563 19.9073 18.0459 20.1176 18.0459 20.3803V28.34C18.0469 28.6027 18.2573 28.813 18.52 28.813Z",
    fill: "#FF5956"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5136 28.813C21.7763 28.813 21.9866 28.6027 21.9866 28.34V20.3803C21.9866 20.1176 21.7763 19.9073 21.5136 19.9073C21.2509 19.9073 21.0405 20.1176 21.0405 20.3803V28.34C21.0405 28.6027 21.2509 28.813 21.5136 28.813Z",
    fill: "#FF5956"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5077 28.813C24.7704 28.813 24.9808 28.6027 24.9808 28.34V20.3803C24.9808 20.1176 24.7704 19.9073 24.5077 19.9073C24.245 19.9073 24.0347 20.1176 24.0347 20.3803V28.34C24.0613 28.6027 24.2717 28.813 24.5077 28.813Z",
    fill: "#FF5956"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete_icon.63bd646f82841e9c5361519df513faed.svg";
export { ForwardRef as ReactComponent };